/* LOTY health theme interactions */
(function () {
  "use strict";

  // Mobile menu toggle
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-loty-menu-toggle]");
    if (toggle) {
      var nav = document.querySelector("[data-loty-mobile-nav]");
      if (nav) nav.classList.toggle("is-open");
    }

    // Product detail tabs
    var tabBtn = e.target.closest("[data-loty-tab]");
    if (tabBtn) {
      var key = tabBtn.getAttribute("data-loty-tab");
      var root = tabBtn.closest("[data-loty-tabs]");
      if (root) {
        root.querySelectorAll("[data-loty-tab]").forEach(function (b) {
          b.classList.toggle("is-active", b === tabBtn);
        });
        root.querySelectorAll("[data-loty-panel]").forEach(function (p) {
          p.classList.toggle("is-active", p.getAttribute("data-loty-panel") === key);
        });
      }
    }

    // Quantity stepper
    var qtyBtn = e.target.closest("[data-loty-qty]");
    if (qtyBtn) {
      var dir = qtyBtn.getAttribute("data-loty-qty");
      var input = qtyBtn.parentElement.querySelector("input");
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        val = dir === "inc" ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      }
    }

    // Collection filter chips (client-side filter by data-tags)
    var chip = e.target.closest("[data-loty-filter]");
    if (chip) {
      var filter = chip.getAttribute("data-loty-filter");
      var wrap = chip.closest("[data-loty-coll]");
      if (wrap) {
        wrap.querySelectorAll("[data-loty-filter]").forEach(function (c) {
          c.classList.toggle("is-active", c === chip);
        });
        wrap.querySelectorAll("[data-loty-item]").forEach(function (item) {
          var tags = (item.getAttribute("data-tags") || "").toLowerCase();
          var show = filter === "all" || tags.indexOf(filter.toLowerCase()) !== -1;
          item.style.display = show ? "" : "none";
        });
      }
    }
  });
})();
